function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgValuablegreater = function SvgValuablegreater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1378,
    height: 1378,
    viewBox: "-10 0 1378 1378"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1368 732-164-21-58-135 221-144Zm-972-31-71 84-267 57-68-366ZM761 0l226 470-237 133-277-188Zm19 652 214-121-108 796-115 49zm-192 680L462 477l257 173-10 728Zm388-251 225-321 150 20-406 533zm184-348L991 975l28-208 91-149zM472 931 370 808l63-75 12 14zm-144-96 158 190 39 263L85 887Z",
    style: {
      fill: "#e63323",
      fillOpacity: 1
    }
  }));
};
export default SvgValuablegreater;